
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputKeyboardScreenGoogle as ObiInputKeyboardScreenGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-keyboard-screen-google.js';
 
 
 

 
 export const ObiInputKeyboardScreenGoogle = createComponent({
   react: React,
   tagName: 'obi-input-keyboard-screen-google',
   elementClass: ObiInputKeyboardScreenGoogleElement,
   events: {
     
   }
  });
 
 